import { render, staticRenderFns } from "./CreateQuestion.vue?vue&type=template&id=6ea484c7"
import script from "./CreateQuestion.vue?vue&type=script&lang=ts"
export * from "./CreateQuestion.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports